<template>
  <el-select
    :value="value"
    clearable
    filterable
    :placeholder="placeholder"
    v-bind="$attrs"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
  >
    <el-option
      v-for="item in options"
      :key="item.groupCode"
      :label="item.groupName"
      :value="item.groupCode"
    />
  </el-select>
</template>

<script>
export default {
  name: 'PlatformGroupSelect',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择平台组'
    }
  },
  data () {
    return {
      options: []
    }
  },
  async mounted () {
    await this.fetchOptions()
  },
  methods: {
    async fetchOptions () {
      const res = await this.$q.newProduct.platformImageRuleGroups()
      this.options = res.data || []
    }
  }
}
</script>
